// Базовый URL PHP API.
// Пустая строка = тот же домен (продакшен на хостинге).
// Локально по умолчанию http://localhost:5000
export const API_ORIGIN =
  process.env.REACT_APP_API_ORIGIN !== undefined
    ? process.env.REACT_APP_API_ORIGIN
    : process.env.NODE_ENV === 'production'
      ? ''
      : 'http://localhost:5000';

export const BASE_URL = API_ORIGIN ? `${API_ORIGIN}/api/v1` : '/api/v1';

/** Базовый URL сайта для SEO-превью (без слэша в конце). */
export const getSiteOrigin = () => {
  const fromEnv = process.env.REACT_APP_SITE_URL?.trim();
  if (fromEnv) {
    return fromEnv.replace(/\/$/, '');
  }
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin;
  }
  return '';
};
